import { ServerResponse } from 'data/types';
import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_DELIVERY_FUNCTION_NETWORK_INTERFACE = '/dfnis';

export const GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LIST = 'GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LIST';
export const GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LIST_PENDING = 'GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LIST_PENDING';
export const GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LIST_FULFILLED = 'GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LIST_FULFILLED';
export const GET_DELIVERY_FUNCTION_NETWORK_INTERFACE = 'GET_DELIVERY_FUNCTION_NETWORK_INTERFACE';
export const GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_PENDING = 'GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_PENDING';
export const GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED = 'GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED';
export const CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE = 'CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE';
export const CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_PENDING = 'CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_PENDING';
export const CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED = 'CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED';
export const CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_REJECTED = 'CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_REJECTED';
export const UPDATE_DELIVERY_FUNCTION_NETWORK_INTERFACE = 'UPDATE_DELIVERY_FUNCTION_NETWORK_INTERFACE';
export const UPDATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED = 'UPDATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED';
export const UPDATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_REJECTED = 'UPDATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_REJECTED';
export const DELETE_DELIVERY_FUNCTION_NETWORK_INTERFACE = 'DELETE_DELIVERY_FUNCTION_NETWORK_INTERFACE';
export const DELETE_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED = 'DELETE_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED';
export const DELETE_DELIVERY_FUNCTION_NETWORK_INTERFACE_REJECTED = 'DELETE_DELIVERY_FUNCTION_NETWORK_INTERFACE_REJECTED';
export const SELECT_DELIVERY_FUNCTION_NETWORK_INTERFACE = 'SELECT_DELIVERY_FUNCTION_NETWORK_INTERFACE';

export const OPEN_DELIVERY_FUNCTION_NETWORK_INTERFACE_CREATE_POPUP = 'OPEN_DELIVERY_FUNCTION_NETWORK_INTERFACE_CREATE_POPUP';
export const CLOSE_DELIVERY_FUNCTION_NETWORK_INTERFACE_CREATE_POPUP = 'CLOSE_DELIVERY_FUNCTION_NETWORK_INTERFACE_CREATE_POPUP';
export const OPEN_DELIVERY_FUNCTION_NETWORK_INTERFACE_EDIT_POPUP = 'OPEN_DELIVERY_FUNCTION_NETWORK_INTERFACE_EDIT_POPUP';
export const CLOSE_DELIVERY_FUNCTION_NETWORK_INTERFACE_EDIT_POPUP = 'CLOSE_DELIVERY_FUNCTION_NETWORK_INTERFACE_EDIT_POPUP';
export const SET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LOADING = 'SET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LOADING';
export const CLOSE_NETWORK_CREATE_POPUP = 'CLOSE_NETWORK_CREATE_POPUP';

export enum DeliveryFunctionNetworkInterfacePrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export type DeliveryFunctionNetworkInterface = {
  id: string
  interface: string
  niid: string
  ipaddr?: string
  netmask?: string
  broadcast?: string
}

export interface DeliveryFunctionNetworkInterfaceState {
  entities: DeliveryFunctionNetworkInterface[]
  single: DeliveryFunctionNetworkInterface | null
  selected: DeliveryFunctionNetworkInterface[]
  createdId: string | null
  ui: DeliveryFunctionNetworkInterfaceUIState
}

export type DeliveryFunctionNetworkInterfaceUIState = {
  isCreatePopupOpen: boolean
  isEditPopupOpen: boolean
  isLoading: boolean
}

export interface OpenDeliveryFunctionNetworkInterfaceCreatePopupAction extends AnyAction {
  type: typeof OPEN_DELIVERY_FUNCTION_NETWORK_INTERFACE_CREATE_POPUP
}

export interface CloseDeliveryFunctionNetworkInterfaceCreatePopupAction extends AnyAction {
  type: typeof CLOSE_DELIVERY_FUNCTION_NETWORK_INTERFACE_CREATE_POPUP
}

export interface OpenDeliveryFunctionNetworkInterfaceEditPopupAction extends AnyAction {
  type: typeof OPEN_DELIVERY_FUNCTION_NETWORK_INTERFACE_EDIT_POPUP
}

export interface CloseDeliveryFunctionNetworkInterfaceEditPopupAction extends AnyAction {
  type: typeof CLOSE_DELIVERY_FUNCTION_NETWORK_INTERFACE_EDIT_POPUP
}

export interface SetDeliveryFunctionNetworkInterfaceLoadingAction extends AnyAction {
  type: typeof SET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LOADING
  payload: { isLoading: boolean }
}

export interface GetDeliveryFunctionNetworkInterfaceListAction extends AnyAction {
  type: typeof GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LIST
  payload: AxiosPromise<ServerResponse<DeliveryFunctionNetworkInterface>>
}

export interface GetDeliveryFunctionNetworkInterfaceListPendingAction extends AnyAction {
  type: typeof GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LIST_PENDING
  payload: null
}

export interface GetDeliveryFunctionNetworkInterfaceListFulfilledAction extends AnyAction {
  type: typeof GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<DeliveryFunctionNetworkInterface>>
}

export interface GetDeliveryFunctionNetworkInterfaceAction extends AnyAction {
  type: typeof GET_DELIVERY_FUNCTION_NETWORK_INTERFACE
  payload: AxiosPromise<ServerResponse<DeliveryFunctionNetworkInterface>>
}

export interface GetDeliveryFunctionNetworkInterfacePendingAction extends AnyAction {
  type: typeof GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_PENDING
  payload: null
}

export interface GetDeliveryFunctionNetworkInterfaceFulfilledAction extends AnyAction {
  type: typeof GET_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED
  payload: AxiosResponse<ServerResponse<DeliveryFunctionNetworkInterface>>
}

export interface CreateDeliveryFunctionNetworkInterfaceThunkAction
  extends ThunkAction<void, RootState, void, AnyAction> {}
export interface CreateDeliveryFunctionNetworkInterfaceAction extends AnyAction {
  type: typeof CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE
  payload: AxiosPromise<ServerResponse<DeliveryFunctionNetworkInterface>>
}

export interface CreateDeliveryFunctionNetworkInterfacePendingAction extends AnyAction {
  type: typeof CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_PENDING
  payload: null
}

export interface CreateDeliveryFunctionNetworkInterfaceFulfilledAction extends AnyAction {
  type: typeof CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED
  payload: AxiosResponse<ServerResponse<DeliveryFunctionNetworkInterface>>
}

export interface CreateDeliveryFunctionNetworkInterfaceRejectedAction extends AnyAction {
  type: typeof CREATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_REJECTED
  payload: AxiosResponse<ServerResponse<DeliveryFunctionNetworkInterface>>
}

export interface UpdateDeliveryFunctionNetworkInterfaceThunkAction
  extends ThunkAction<void, RootState, void, AnyAction> {}
export interface UpdateDeliveryFunctionNetworkInterfaceAction extends AnyAction {
  type: typeof UPDATE_DELIVERY_FUNCTION_NETWORK_INTERFACE
  payload: AxiosPromise<ServerResponse<DeliveryFunctionNetworkInterface>>
}

export interface UpdateDeliveryFunctionNetworkInterfaceFulfilledAction extends AnyAction {
  type: typeof UPDATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED
  payload: AxiosResponse<ServerResponse<DeliveryFunctionNetworkInterface>>
}

export interface UpdateDeliveryFunctionNetworkInterfaceRejectedAction extends AnyAction {
  type: typeof UPDATE_DELIVERY_FUNCTION_NETWORK_INTERFACE_REJECTED
  payload: AxiosResponse<ServerResponse<DeliveryFunctionNetworkInterface>>
}

export interface DeleteDeliveryFunctionNetworkInterfaceThunkAction
  extends ThunkAction<void, RootState, void, AnyAction> {}
export interface DeleteDeliveryFunctionNetworkInterfaceAction extends AnyAction {
  type: typeof DELETE_DELIVERY_FUNCTION_NETWORK_INTERFACE
  payload: AxiosPromise<ServerResponse<DeliveryFunctionNetworkInterface>>
}

export interface DeleteDeliveryFunctionNetworkInterfaceFulfilledAction extends AnyAction {
  type: typeof DELETE_DELIVERY_FUNCTION_NETWORK_INTERFACE_FULFILLED
  payload: AxiosResponse<ServerResponse<DeliveryFunctionNetworkInterface>>
}

export interface DeleteDeliveryFunctionNetworkInterfaceRejectedAction extends AnyAction {
  type: typeof DELETE_DELIVERY_FUNCTION_NETWORK_INTERFACE_REJECTED
  payload: AxiosResponse<ServerResponse<DeliveryFunctionNetworkInterface>>
}

export interface SelectDeliveryFunctionNetworkInterfaceAction extends AnyAction{
  type: typeof SELECT_DELIVERY_FUNCTION_NETWORK_INTERFACE
  payload: DeliveryFunctionNetworkInterface[]
}

export type DeliveryFunctionNetworkInterfaceActionTypes =
  OpenDeliveryFunctionNetworkInterfaceCreatePopupAction |
  CloseDeliveryFunctionNetworkInterfaceCreatePopupAction |
  OpenDeliveryFunctionNetworkInterfaceEditPopupAction |
  CloseDeliveryFunctionNetworkInterfaceEditPopupAction |
  SetDeliveryFunctionNetworkInterfaceLoadingAction |
  GetDeliveryFunctionNetworkInterfaceListAction |
  GetDeliveryFunctionNetworkInterfaceListPendingAction |
  GetDeliveryFunctionNetworkInterfaceListFulfilledAction |
  GetDeliveryFunctionNetworkInterfaceAction |
  GetDeliveryFunctionNetworkInterfacePendingAction |
  GetDeliveryFunctionNetworkInterfaceFulfilledAction |
  CreateDeliveryFunctionNetworkInterfaceAction |
  CreateDeliveryFunctionNetworkInterfacePendingAction |
  CreateDeliveryFunctionNetworkInterfaceFulfilledAction |
  CreateDeliveryFunctionNetworkInterfaceRejectedAction |
  UpdateDeliveryFunctionNetworkInterfaceAction |
  UpdateDeliveryFunctionNetworkInterfaceFulfilledAction |
  UpdateDeliveryFunctionNetworkInterfaceRejectedAction |
  DeleteDeliveryFunctionNetworkInterfaceAction |
  DeleteDeliveryFunctionNetworkInterfaceFulfilledAction |
  DeleteDeliveryFunctionNetworkInterfaceRejectedAction |
  SelectDeliveryFunctionNetworkInterfaceAction;
